import { System } from "titum-custom/details";
import { SYSTEM_EDITIONS } from "Components/Constants/SystemEditions";
import { menuConfigPOS } from "./menuPOS";
import { menuConfigAutoCare } from "./menuAutoCare";
import { useSelector } from "react-redux";



const DefaultMenu = (props) => {
    const user = useSelector((state) => state.auth);
    const { MenuCard} = props;

    return (
        System.SYSTEM_EDITION == SYSTEM_EDITIONS.BIZ_X_POS &&
        menuConfigPOS
            .filter((props) => props.auth === user?.userData.role[0])[0]
            .menus.map((menu, index) => (
                <MenuCard key={index} menu={menu} />
            )) ||
        System.SYSTEM_EDITION == SYSTEM_EDITIONS.BIZ_X_AUTO_CARE &&
        menuConfigAutoCare
            .filter((props) => props.auth === user?.userData.role[0])[0]
            .menus.map((menu, index) => (
                <MenuCard key={index} menu={menu} />
            ))
    );
};

export default DefaultMenu;
